<template>
  <div class="checkboxAll" :class="checkboxOther && checkboxPicture? 'checkboxMargin':''">
    <div v-if="checkboxPicture == false" class="checkboxNoPic">
      <CheckboxGroup
        style="height: 30px; display:inline-block;margin-right: 30px;"
        v-for="(option, index) in multipleChoiceList"
        :key="index"
        v-model="checkboxDate"
        @on-change="selectCheckbox"
      >
        <Checkbox :option="option" :label="option.label" :value="option.label" shape="square"></Checkbox>
      </CheckboxGroup>
      <div v-for="(i, inx) in checkboxOther" :key="inx + 'input'">
        <Input
          type="textarea"
          :rows="4"
          v-if="i.other"
          v-model="i.otherOptionAnswer"
          :placeholder="i.otherPrompt ? i.otherPrompt : '请填写说明'"
        />
      </div>
    </div>
    <!-- 有图片的选项 -->
    <div v-else class>
      <CheckboxGroup
        v-for="(option, index) in multipleChoiceList"
        :key="index + 'group'"
        v-model="checkboxDate"
        @on-change="selectCheckbox"
        class="checkboxPic_content checkboxPic"
        v-bind:class="{'checkboxPicHover': option.class=== true && option.images.length !== 0, 'checkbox_pic_noImage': option.images.length === 0}"
      >
        <img v-for="(i, _index) in option.images" :key="_index + 'img'" :src="i" />
        <Checkbox :option="option" :label="option.label" :value="option.label" shape="square"></Checkbox>
      </CheckboxGroup>
      <div v-for="(i, inx) in checkboxOther" :key="inx + 'input'">
        <Input
          type="textarea"
          :rows="4"
          v-if="i.other"
          v-model="i.otherOptionAnswer"
          :placeholder="i.otherPrompt ? i.otherPrompt : '请填写说明'"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['item', 'pindex'],
  data() {
    return {
      // 多选题
      checkboxDate: [], //默认值0-0
      checkboxOther: [],
      checkboxPicture: false,
      // 判断是否有other
      showOtherIndex: -1,
      showOtherItem: {},
      // 添加样式
      clickClass: [],
      multipleChoiceList: [],
    }
  },
  created: function () {
    // console.log(this.item)
    // 设置查看答案的默认值
    // console.log(this.item.value.multipleChoiceAttribute)
    if (this.item.value.multipleChoiceAttribute.answer.length != 0) {
      this.item.value.multipleChoiceAttribute.answer.forEach((_item) => {
        this.checkboxDate.push(_item.name)
        this.checkboxOther.push(_item)
      })
    } else {
      // this.item.value.multipleChoiceOptions.map((i, index) => {
      //   if (i.defaultValue == true) {
      //     this.checkboxDate.push(this.pindex + "-" + index);
      //     // console.log(this.checkboxDate);
      //   }
      // });
    }
    // 设置问卷初始默认值
    this.item.value.multipleChoiceOptions.map((i, index) => {
      if (i.images.length != 0) {
        this.checkboxPicture = true
      }
      // if (i.other == true) {
      //   this.showOtherIndex = index;
      //   this.showOtherItem = i;
      // }
      // this.clickClass.push(false);
    })
    this.selectOptionsCheckbox(this.item, this.pindex)
  },
  mounted: function () {
    // 添加边框样式
    // if (this.checkboxDate.length > 0 && this.checkboxPicture == true) {
    //   this.checkboxDate.map((item, index) => {
    //     this.clickClass[Number(item.charAt(item.length - 1))] = true;
    //   });
    // }
  },
  methods: {
    // 多选题
    selectOptionsCheckbox: function (select, pindex) {
      const multipleChoiceOptions = select.value.multipleChoiceOptions
      multipleChoiceOptions.forEach((item, index) => {
        this.$set(item, 'label', item.name)
        if (this.checkboxDate.indexOf(item.name) > -1) {
          this.$set(item, 'class', true)
        } else {
          this.$set(item, 'class', false)
        }
      })
      this.multipleChoiceList = multipleChoiceOptions
      // return multipleChoiceOptions;
    },
    selectCheckbox: function (val) {
      this.checkboxOther = []
      console.log(val)
      this.multipleChoiceList.forEach((_item) => {
        if (val.indexOf(_item.name) > -1) {
          _item.class = true
          this.checkboxOther.push(_item)
        } else {
          _item.class = false
        }
      })
      console.log(this.checkboxOther)

      this.item.value.multipleChoiceAttribute.verifyStatus = true
      if (
        this.item.value.multipleChoiceAttribute.minChoiceQuantity !== '' &&
        val.length <
          Number(this.item.value.multipleChoiceAttribute.minChoiceQuantity)
      ) {
        this.$Message.warning(
          this.item.value.multipleChoiceAttribute.errorMessage != ''
            ? this.item.value.multipleChoiceAttribute.errorMessage
            : '最少选择' +
                this.item.value.multipleChoiceAttribute.minChoiceQuantity +
                '选项'
        )
        this.item.value.multipleChoiceAttribute.verifyStatus = false
      } else if (
        this.item.value.multipleChoiceAttribute.maxChoiceQuantity != '' &&
        val.length > this.item.value.multipleChoiceAttribute.maxChoiceQuantity
      ) {
        this.$Message.warning(
          this.item.value.multipleChoiceAttribute.errorMessage != ''
            ? this.item.value.multipleChoiceAttribute.errorMessage
            : '最多选择' +
                this.item.value.multipleChoiceAttribute.maxChoiceQuantity +
                '选项'
        )
        this.item.value.multipleChoiceAttribute.verifyStatus = false
      } else {
        this.item.value.multipleChoiceAttribute.verifyStatus = true
        this.item.value.multipleChoiceAttribute.answer = this.checkboxOther
        // console.log(newcheckbox);

        this.$emit('checkboxDate', this.checkboxOther)
      }
    },
  },

  watch: {},
}
</script>
<style lang="less" scoped>
.checkboxAll {
  width: 100%;
}

/* 有图片 */
.checkboxPic {
  /* float:left; */
  display: flex;
}
.checkboxPic_content {
  flex: 1;
  width: 150px;
  display: inline-block;
  margin-bottom: 10px;
  /* position: relative; */
  /* width: 100%; */
  /* height: 200px; */
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 3px;
  margin-right: 3%;
}
.checkbox_pic_noImage {
  border: none;
}

.checkboxPic_content img {
  width: 100%;
  height: 150px;
  border-radius: 5px;
  margin-bottom: 10px;
}
.checkboxPic_content input {
  opacity: 0;
  z-index: 10;
  position: absolute;
  bottom: 0;
  left: 0;
}

.checkbox_picbottom {
  display: inline-block;
  width: 12px;
  height: 12px;
  line-height: 20px;
  margin-right: 10px;
  position: relative;
  border: 1px solid rgb(220, 220, 220);
  border-radius: 50%;
}
/* .checkbox_pic .checkboxPic_content label {
  line-height: 20px;
} */
.checkbox_pic .checkboxOption {
  width: 38%;
  height: 33px;
  border: 1px solid rgb(220, 220, 220);
  border-radius: 5px;
  padding-left: 10px;
  box-sizing: border-box;
  background-color: rgb(246, 248, 252);
  margin-bottom: 10px;
}

.checkboxPicHover {
  border: 1px solid #57a3f3;
}
.checkboxPic .checkboxInputPic {
  /* display:inline-block; */
  width: 90%;
  position: absolute;
  bottom: 0px;
  left: 5%;
  height: 33px;
  /* border: 1px solid rgb(220, 220, 220); */
  border-radius: 5px;
  /* padding-left: 10px; */
  box-sizing: border-box;
  /* background-color: rgb(246, 248, 252); */
}
</style>


